import { createAction, props } from '@ngrx/store';
import { Order } from '@app/services/order/order.model';
import { QueryParameters } from '@app/core/entities/query-parameters.class';

const actionPrefix = '[Preview][Orders]';

export const loadPreviewOrders = createAction(`${actionPrefix} Load`, props<{ queryParameters: QueryParameters }>());
export const loadPreviewOrdersSuccess = createAction(
  `${actionPrefix} Load Success`,
  props<{ orders: Order[]; count: number; inc?: number }>(),
);
export const loadPreviewOrdersFailure = createAction(`${actionPrefix} Load Failure`);

export const loadPreviewOrdersCount = createAction(
  `${actionPrefix} Load Count`,
  props<{ queryParameters: QueryParameters }>(),
);
export const loadPreviewOrdersCountSuccess = createAction(
  `${actionPrefix} Load Count Success`,
  props<{ count: number }>(),
);
export const loadPreviewOrdersCountFailure = createAction(`${actionPrefix} Load Count Failure`);

export const setPreviewOrdersLoading = createAction(`${actionPrefix} Set Loading`, props<{ loading: boolean }>());
